import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call, put } from 'redux-saga/effects';
import { Company } from 'types';

/**
 * Fetch
 */
type DataFetch = Array<Company>;

export const companiesFetch = createApiSlice<DataFetch>({
  name: 'companiesFetch',
  *tryGenerator() {
    const { data } = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({ path: '/auth/company' }),
    });

    return data;
  },
});

/**
 * Add
 */
type PayloadAdd = Record<string, unknown>;

export const companiesAdd = createApiSlice<unknown, PayloadAdd>({
  name: 'companiesAdd',
  *tryGenerator(_, { payload: data }) {
    yield call(amplifyClient, {
      method: 'post',
      url: getEndpointV2({ path: '/auth/company' }),
      data,
    });

    yield put(companiesFetch.actions.call());

    return null;
  },
});

/**
 * Remove
 */

type PayloadRemove = {
  data: { id: string };
};

export const companiesRemove = createApiSlice<unknown, PayloadRemove>({
  name: 'companiesRemove',
  *tryGenerator(_, { payload: { data } }) {
    const { id: companyId } = data;

    yield call(amplifyClient, {
      method: 'del',
      url: getEndpointV2({ path: '/auth/company/:companyId', urlParams: { companyId } }),
    });

    yield put(companiesFetch.actions.call());

    return null;
  },
});
